import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
import { formatShieldUrl } from '../../common/models/Rival';
export default class BolillaRetroGame extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "hasStarted", false);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "roundId", '');
    _defineProperty(this, "matches", []);
    _defineProperty(this, "currentIndex", 0);
    // Game Mode & Level Selection
    _defineProperty(this, "selectedLevel", 1);
    // 1: 2010-2027, 2: 1980-2009, 3: 1901-1979
    _defineProperty(this, "isSurvival", false);
    // Modo Muerte Súbita (3 vidas)
    // User answers map for Classic Mode: matchId -> optionKey
    _defineProperty(this, "answers", {});
    _defineProperty(this, "skippedMatches", {});
    // Survival Mode State
    _defineProperty(this, "lives", 3);
    _defineProperty(this, "survivalStreak", 0);
    _defineProperty(this, "survivalFeedback", null);
    _defineProperty(this, "survivalAnswers", []);
    // Timer
    _defineProperty(this, "timerSeconds", 0);
    _defineProperty(this, "timerInterval", null);
    // Advance timeout
    _defineProperty(this, "advanceTimeout", null);
    // Results
    _defineProperty(this, "isFinished", false);
    _defineProperty(this, "results", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const attrs = vnode && vnode.attrs || this.attrs || {};
    if (attrs.level) {
      this.selectedLevel = parseInt(attrs.level, 10) || 1;
    }
    if (attrs.survival !== undefined) {
      this.isSurvival = Boolean(attrs.survival);
    }
    this.fetchNewRound();
  }
  onremove(vnode) {
    this.stopTimer();
    this.clearAdvanceTimeout();
    super.onremove(vnode);
  }
  clearAdvanceTimeout() {
    if (this.advanceTimeout) {
      clearTimeout(this.advanceTimeout);
      this.advanceTimeout = null;
    }
  }
  startTimer() {
    this.stopTimer();
    this.timerSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.timerSeconds++;
      m.redraw();
    }, 1000);
  }
  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
  selectLevel(level, isSurvival) {
    if (isSurvival === void 0) {
      isSurvival = false;
    }
    if (this.selectedLevel === level && this.isSurvival === isSurvival && !this.isFinished) {
      return;
    }
    this.selectedLevel = level;
    this.isSurvival = isSurvival;
    this.fetchNewRound();
  }
  fetchNewRound() {
    this.loading = true;
    this.hasStarted = false;
    this.submitting = false;
    this.isFinished = false;
    this.results = null;
    this.answers = {};
    this.skippedMatches = {};
    this.survivalAnswers = [];
    this.survivalFeedback = null;
    this.survivalStreak = 0;
    this.lives = 3;
    this.currentIndex = 0;
    this.stopTimer();
    this.clearAdvanceTimeout();
    const url = "".concat(app.forum.attribute('apiUrl'), "/nagusi/games/bolilla-retro/round?level=").concat(this.selectedLevel, "&survival=").concat(this.isSurvival ? '1' : '0');
    app.request({
      method: 'GET',
      url: url
    }).then(response => {
      this.roundId = response.round_id || '';
      this.matches = response.matches || [];
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar los partidos de Bolilla Retro. Inténtalo de nuevo.');
      m.redraw();
    });
  }
  startGame() {
    this.hasStarted = true;
    this.lives = 3;
    this.survivalStreak = 0;
    this.survivalFeedback = null;
    this.survivalAnswers = [];
    this.startTimer();
    m.redraw();
  }
  selectOption(matchId, optionKey) {
    if (this.submitting || this.isFinished) return;

    // --- MODO MUERTE SÚBITA ---
    if (this.isSurvival) {
      if (this.survivalFeedback) return; // Prevent click while animation/feedback is playing

      const currentMatch = this.matches[this.currentIndex];
      if (!currentMatch || currentMatch.id !== matchId) return;
      const isCorrect = optionKey === currentMatch.correct_key;
      this.survivalFeedback = {
        matchId,
        pickedKey: optionKey,
        isCorrect
      };
      this.survivalAnswers.push({
        id: matchId,
        answer: optionKey
      });
      if (isCorrect) {
        this.survivalStreak++;
        m.redraw();

        // Advance to next match after brief celebration
        this.advanceTimeout = setTimeout(() => {
          this.survivalFeedback = null;
          if (this.currentIndex + 1 < this.matches.length) {
            this.currentIndex++;
          } else {
            // Exhausted 50-match survival pool (legendary run)
            this.submitSurvivalRound();
          }
          m.redraw();
        }, 650);
      } else {
        this.lives--;
        m.redraw();
        if (this.lives > 0) {
          // Still has lives, allow viewing the correct answer for 1.1s, then advance
          this.advanceTimeout = setTimeout(() => {
            this.survivalFeedback = null;
            if (this.currentIndex + 1 < this.matches.length) {
              this.currentIndex++;
            } else {
              this.submitSurvivalRound();
            }
            m.redraw();
          }, 1100);
        } else {
          // 0 lives left -> Game Over!
          this.stopTimer();
          this.advanceTimeout = setTimeout(() => {
            this.submitSurvivalRound();
          }, 900);
        }
      }
      return;
    }

    // --- MODO CLÁSICO ---
    this.clearAdvanceTimeout();
    this.answers[matchId] = optionKey;
    this.skippedMatches[matchId] = false;
    m.redraw();

    // Auto-advance to next unanswered match after brief moment
    this.advanceTimeout = setTimeout(() => {
      const nextUnanswered = this.findNextUnansweredIndex(this.currentIndex);
      if (nextUnanswered !== -1) {
        this.currentIndex = nextUnanswered;
      }
      m.redraw();
    }, 250);
  }
  skipCurrentMatch() {
    if (this.isSurvival) return; // In survival mode, matches cannot be skipped

    this.clearAdvanceTimeout();
    const currentMatch = this.matches[this.currentIndex];
    if (currentMatch) {
      this.skippedMatches[currentMatch.id] = true;
    }
    const nextPending = this.findNextPendingOrSkippedIndex(this.currentIndex);
    if (nextPending !== -1) {
      this.currentIndex = nextPending;
    }
    m.redraw();
  }
  findNextUnansweredIndex(fromIndex) {
    for (let i = fromIndex + 1; i < this.matches.length; i++) {
      const mId = this.matches[i].id;
      if (!this.answers[mId]) {
        return i;
      }
    }
    for (let i = 0; i < fromIndex; i++) {
      const mId = this.matches[i].id;
      if (!this.answers[mId]) {
        return i;
      }
    }
    return -1;
  }
  findNextPendingOrSkippedIndex(fromIndex) {
    for (let i = fromIndex + 1; i < this.matches.length; i++) {
      const mId = this.matches[i].id;
      if (!this.answers[mId]) {
        return i;
      }
    }
    for (let i = 0; i <= fromIndex; i++) {
      const mId = this.matches[i].id;
      if (!this.answers[mId]) {
        return i;
      }
    }
    return -1;
  }
  goToMatch(idx) {
    if (this.isSurvival) return; // In survival mode navigation is strictly forward
    if (idx >= 0 && idx < this.matches.length) {
      this.clearAdvanceTimeout();
      this.currentIndex = idx;
      m.redraw();
    }
  }
  allMatchesAnswered() {
    if (!this.matches.length) return false;
    return this.matches.every(m => Boolean(this.answers[m.id]));
  }
  submitClassicRound() {
    if (this.submitting || this.isFinished) return;
    this.submitting = true;
    this.stopTimer();
    const payloadAnswers = this.matches.map(m => ({
      id: m.id,
      answer: this.answers[m.id] || ''
    }));
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/bolilla-retro/submit',
      body: {
        round_id: this.roundId,
        level: this.selectedLevel,
        survival: false,
        answers: payloadAnswers,
        duration_seconds: this.timerSeconds
      }
    }).then(response => {
      this.submitting = false;
      this.isFinished = true;
      this.results = response;
      m.redraw();
    }).catch(err => {
      this.submitting = false;
      const msg = err && err.response && err.response.error || 'Error al enviar tus resultados.';
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  submitSurvivalRound() {
    if (this.submitting || this.isFinished) return;
    this.submitting = true;
    this.stopTimer();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/bolilla-retro/submit',
      body: {
        round_id: this.roundId,
        level: 1,
        survival: true,
        answers: this.survivalAnswers,
        duration_seconds: this.timerSeconds
      }
    }).then(response => {
      this.submitting = false;
      this.isFinished = true;
      this.results = response;
      m.redraw();
    }).catch(err => {
      this.submitting = false;
      const msg = err && err.response && err.response.error || 'Error al enviar tus resultados de Muerte Súbita.';
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  formatTimer(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return "".concat(m, ":").concat(s < 10 ? '0' : '').concat(s);
  }
  renderLevelSelector() {
    const baseUrl = (app.forum.attribute('baseUrl') || '').replace(/\/$/, '');
    const txapelaLionUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-txapela");
    const levels = [{
      id: 1,
      isSurvival: false,
      name: 'Nivel 1',
      desc: '2010–2027 (Moderna)'
    }, {
      id: 2,
      isSurvival: false,
      name: 'Nivel 2',
      desc: '1980–2009 (Años de Oro)'
    }, {
      id: 3,
      isSurvival: false,
      name: 'Nivel 3',
      desc: '1901–1979 (Histórica)'
    }, {
      id: 4,
      isSurvival: true,
      name: 'Muerte Súbita',
      desc: '3 Vidas de León',
      hasLion: true
    }];
    return m("div", {
      className: "bolilla-levels-bar"
    }, m("div", {
      className: "level-pills"
    }, levels.map(lvl => {
      const isActive = lvl.isSurvival ? this.isSurvival : !this.isSurvival && this.selectedLevel === lvl.id;
      return m("button", {
        key: lvl.name,
        type: "button",
        className: "level-pill ".concat(isActive ? 'active' : '', " ").concat(lvl.isSurvival ? 'is-survival' : ''),
        onclick: () => this.selectLevel(lvl.isSurvival ? 1 : lvl.id, lvl.isSurvival)
      }, m("div", {
        className: "pill-title-row"
      }, lvl.hasLion && m("img", {
        src: txapelaLionUrl,
        className: "pill-lion-icon",
        alt: "Le\xF3n"
      }), m("span", {
        className: "pill-title"
      }, lvl.name)), m("span", {
        className: "pill-desc"
      }, lvl.desc));
    })));
  }
  renderSurvivalLives() {
    const baseUrl = (app.forum.attribute('baseUrl') || '').replace(/\/$/, '');
    const aliveLionUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-txapela");
    const criticalLionUrl = "".concat(baseUrl, "/api/custom-emojis/ee-urduri");
    const lostLionUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-triste");

    // 3 lives display
    const lifeIcons = [];
    for (let i = 1; i <= 3; i++) {
      if (this.lives >= i) {
        // If only 1 life remains, render the nervous sweating lion
        if (this.lives === 1) {
          lifeIcons.push(m("img", {
            key: i,
            src: criticalLionUrl,
            className: "lion-life-icon critical",
            alt: "\xA1\xDAltima Vida!",
            title: "\xA1Cuidado! Te queda solo 1 vida de le\xF3n"
          }));
        } else {
          lifeIcons.push(m("img", {
            key: i,
            src: aliveLionUrl,
            className: "lion-life-icon alive",
            alt: "Vida activa",
            title: "Vida de Le\xF3n ".concat(i)
          }));
        }
      } else {
        lifeIcons.push(m("img", {
          key: i,
          src: lostLionUrl,
          className: "lion-life-icon lost",
          alt: "Vida perdida",
          title: "Vida perdida"
        }));
      }
    }
    return m("div", {
      className: "survival-hud"
    }, m("div", {
      className: "survival-lives"
    }, lifeIcons), m("div", {
      className: "survival-streak-badge"
    }, m("i", {
      className: "fas fa-fire"
    }), " Ronda ", this.survivalStreak + 1));
  }
  view() {
    try {
      if (this.loading) {
        return m("div", {
          className: "bolilla-retro-game loading-state",
          style: {
            padding: '40px 0',
            textAlign: 'center'
          }
        }, m(LoadingIndicator, null), m("p", {
          style: {
            marginTop: '12px',
            color: '#64748b',
            fontWeight: 600
          }
        }, "Cargando partidos de Bolilla Retro..."));
      }
      if (this.isFinished && this.results) {
        return m("div", {
          className: "bolilla-retro-game"
        }, this.renderLevelSelector(), this.renderResults());
      }
      if (!this.hasStarted) {
        return m("div", {
          className: "bolilla-retro-game"
        }, this.renderLevelSelector(), this.renderWelcome());
      }
      return m("div", {
        className: "bolilla-retro-game"
      }, this.renderLevelSelector(), this.renderGameScreen());
    } catch (e) {
      console.error('BolillaRetroGame render error:', e);
      return m("div", {
        className: "bolilla-retro-game error-state",
        style: {
          padding: '30px',
          textAlign: 'center'
        }
      }, m("p", null, "Ocurri\xF3 un error al cargar la partida."), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.fetchNewRound()
      }, "Reintentar"));
    }
  }
  renderWelcome() {
    if (this.isSurvival) {
      return m("div", {
        className: "bolilla-retro-game welcome-card"
      }, m("div", {
        className: "welcome-hero"
      }, m("span", {
        className: "welcome-emoji"
      }, "\uD83E\uDD81\uD83D\uDD25"), m("h2", null, "Bolilla Retro: Muerte S\xFAbita (3 Vidas)"), m("p", {
        className: "welcome-desc"
      }, "El desaf\xEDo definitivo para los aut\xE9nticos leones de la memoria zurigorri. Partidos de cualquier \xE9poca de los ", m("strong", null, "126 a\xF1os de historia del Athletic Club"), " (1901\u20132027). \xA1Tienes ", m("strong", null, "3 vidas de le\xF3n"), "! Cada error te resta una vida. \xBFCu\xE1ntas rondas lograr\xE1s superar antes de que te expulsen?")), m("div", {
        className: "welcome-rules-grid"
      }, m("div", {
        className: "rule-item"
      }, m("div", {
        className: "rule-icon"
      }, "\uD83E\uDD81"), m("div", null, m("strong", null, "3 Vidas del Le\xF3n"), m("p", null, "Cada marcador o suspensi\xF3n fallada te arrebata una vida. Al quedarte 1 vida, el le\xF3n sudar\xE1 de puro suspense."))), m("div", {
        className: "rule-item"
      }, m("div", {
        className: "rule-icon"
      }, "\uD83D\uDD25"), m("div", null, m("strong", null, "Rondas consecutivas"), m("p", null, "Avanza ronda tras ronda sin l\xEDmite. El juego no termina hasta que cometas 3 fallos."))), m("div", {
        className: "rule-item"
      }, m("div", {
        className: "rule-icon"
      }, "\uD83D\uDCDC"), m("div", null, m("strong", null, "Historial Completo (1901\u20132027)"), m("p", null, "Desde los primeros t\xEDtulos de Copa y la era Pentland hasta la Copa 25 de 2024."))), m("div", {
        className: "rule-item"
      }, m("div", {
        className: "rule-icon"
      }, "\uD83C\uDFC6"), m("div", null, m("strong", null, "Sal\xF3n de la Fama - Muerte S\xFAbita"), m("p", null, "Clasificaci\xF3n exclusiva por ronda m\xE1xima alcanzada. No suma puntos al ranking global regular.")))), m("div", {
        className: "welcome-actions"
      }, m(Button, {
        className: "Button Button--primary Button--block btn-start-game",
        icon: "fas fa-play",
        onclick: () => this.startGame()
      }, "\xA1Iniciar Desaf\xEDo Muerte S\xFAbita!")));
    }
    const levelTitles = {
      1: 'Nivel 1: Memoria Zurigorri (2010–2027)',
      2: 'Nivel 2: Años de Oro y Transición (1980–2009)',
      3: 'Nivel 3: La Catedral Histórica (1901–1979)'
    };
    const levelDescs = {
      1: 'Revive el fútbol moderno: la era Bielsa, los títulos de Supercopa y la histórica Copa del Rey 2024 en La Cartuja.',
      2: 'Las legendarias Ligas de Javier Clemente, el Subcampeonato del Centenario de 1998 y la transición a San Mamés Barria.',
      3: 'Los orígenes del club, la temible primera delantera histórica (Lafuente, Bata, Gorostiza) y la época dorada de Telmo Zarra y Gainza.'
    };
    return m("div", {
      className: "bolilla-retro-game welcome-card"
    }, m("div", {
      className: "welcome-hero"
    }, m("span", {
      className: "welcome-emoji"
    }, "\u26BD"), m("h2", null, "Bolilla Retro \u2014 ", levelTitles[this.selectedLevel] || levelTitles[1]), m("p", {
      className: "welcome-desc"
    }, levelDescs[this.selectedLevel] || levelDescs[1], m("br", null), "Demuestra tu memoria zurigorri adivinando el resultado oficial de ", m("strong", null, "5 partidos"), ".")), m("div", {
      className: "welcome-rules-grid"
    }, m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83C\uDFAF"), m("div", null, m("strong", null, "200 puntos por partido"), m("p", null, "Hasta 1.000 puntos en esta tanda (\xA13.000 pts en total sumando los 3 niveles!)."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\u23F1\uFE0F"), m("div", null, m("strong", null, "Tiempo y bonus"), m("p", null, "Primeros 10 segundos de cortes\xEDa sin penalizaci\xF3n; despu\xE9s -2 pts por segundo."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\u23F8\uFE0F"), m("div", null, m("strong", null, "Partidos suspendidos"), m("p", null, "\xA1Atento! Algunos partidos fueron suspendidos o aplazados por causas meteorol\xF3gicas o de fuerza mayor."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83C\uDFDF\uFE0F"), m("div", null, m("strong", null, "Local o Visitante"), m("p", null, "F\xEDjate bien si el Athletic jugaba en San Mam\xE9s o a domicilio al elegir el marcador.")))), m("div", {
      className: "welcome-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block btn-start-game",
      icon: "fas fa-play",
      onclick: () => this.startGame()
    }, "\xA1Comenzar Tanda!")));
  }
  renderGameScreen() {
    var _this$survivalFeedbac;
    const currentMatch = this.matches[this.currentIndex];
    if (!currentMatch) return null;
    const answeredCount = Object.keys(this.answers).filter(k => Boolean(this.answers[parseInt(k, 10)])).length;
    const allDone = this.allMatchesAnswered();
    const selectedAnswer = this.isSurvival ? (_this$survivalFeedbac = this.survivalFeedback) == null ? void 0 : _this$survivalFeedbac.pickedKey : this.answers[currentMatch.id];
    const athleticEscudo = '/assets/extensions/nagusi-match-ratings/escudos/athletic-club.png';
    const rivalEscudo = formatShieldUrl(currentMatch.rival_escudo) || '';
    const compIconUrl = currentMatch.comp_icon ? "/assets/extensions/nagusi-match-ratings/competitions/".concat(currentMatch.comp_icon) : '';
    return m("div", {
      className: "bolilla-retro-game play-screen"
    }, m("div", {
      className: "game-top-bar"
    }, this.isSurvival ? this.renderSurvivalLives() : m("div", {
      className: "match-stepper"
    }, this.matches.map((mItem, idx) => {
      const isSelected = idx === this.currentIndex;
      const isAnswered = Boolean(this.answers[mItem.id]);
      const isSkipped = Boolean(this.skippedMatches[mItem.id]) && !isAnswered;
      let statusClass = 'pending';
      if (isSelected) {
        statusClass = 'active';
      } else if (isAnswered) {
        statusClass = 'completed';
      } else if (isSkipped) {
        statusClass = 'skipped';
      }
      return m("button", {
        type: "button",
        className: "stepper-pill ".concat(statusClass),
        onclick: () => this.goToMatch(idx),
        title: "Partido ".concat(idx + 1, ": ").concat(mItem.rival_name)
      }, m("span", {
        className: "step-num"
      }, idx + 1), isAnswered && m("i", {
        className: "fas fa-check step-icon"
      }), isSkipped && m("i", {
        className: "fas fa-forward step-icon"
      }));
    })), m("div", {
      className: "game-timer-badge"
    }, m("i", {
      className: "far fa-clock"
    }), m("span", null, this.formatTimer(this.timerSeconds)))), m("div", {
      className: "retro-match-card"
    }, m("div", {
      className: "match-meta-bar"
    }, m("div", {
      className: "comp-badge",
      style: {
        borderColor: currentMatch.comp_color,
        color: currentMatch.comp_color
      }
    }, compIconUrl ? m("img", {
      src: compIconUrl,
      alt: currentMatch.comp_name,
      className: "comp-icon",
      style: {
        width: '18px',
        height: '18px',
        maxWidth: '18px',
        maxHeight: '18px',
        objectFit: 'contain'
      }
    }) : m("i", {
      className: "fas fa-trophy"
    }), m("span", null, currentMatch.comp_name)), m("div", {
      className: "match-info-meta"
    }, currentMatch.season && m("span", {
      className: "meta-pill"
    }, currentMatch.season), currentMatch.jornada && m("span", {
      className: "meta-pill"
    }, currentMatch.jornada), currentMatch.date && m("span", {
      className: "meta-pill"
    }, currentMatch.date))), m("div", {
      className: "venue-indicator"
    }, currentMatch.is_local ? m("span", {
      className: "badge-venue local"
    }, m("i", {
      className: "fas fa-home"
    }), " San Mam\xE9s (Local)") : m("span", {
      className: "badge-venue away"
    }, m("i", {
      className: "fas fa-plane"
    }), " A Domicilio (Visitante)")), m("div", {
      className: "matchup-banner"
    }, currentMatch.is_local ? m("div", {
      className: "matchup-teams"
    }, m("div", {
      className: "team-box local-team"
    }, m("img", {
      src: athleticEscudo,
      alt: "Athletic Club",
      className: "team-crest",
      style: {
        width: '58px',
        height: '58px',
        maxWidth: '58px',
        maxHeight: '58px',
        objectFit: 'contain'
      }
    }), m("span", {
      className: "team-name"
    }, "Athletic Club"), m("span", {
      className: "team-tag"
    }, "Local")), m("div", {
      className: "matchup-vs"
    }, "VS"), m("div", {
      className: "team-box away-team"
    }, rivalEscudo ? m("img", {
      src: rivalEscudo,
      alt: currentMatch.rival_name,
      className: "team-crest",
      style: {
        width: '58px',
        height: '58px',
        maxWidth: '58px',
        maxHeight: '58px',
        objectFit: 'contain'
      }
    }) : m("div", {
      className: "team-crest-placeholder"
    }, "\uD83D\uDEE1\uFE0F"), m("span", {
      className: "team-name"
    }, currentMatch.rival_name), m("span", {
      className: "team-tag"
    }, "Visitante"))) : m("div", {
      className: "matchup-teams"
    }, m("div", {
      className: "team-box local-team"
    }, rivalEscudo ? m("img", {
      src: rivalEscudo,
      alt: currentMatch.rival_name,
      className: "team-crest",
      style: {
        width: '58px',
        height: '58px',
        maxWidth: '58px',
        maxHeight: '58px',
        objectFit: 'contain'
      }
    }) : m("div", {
      className: "team-crest-placeholder"
    }, "\uD83D\uDEE1\uFE0F"), m("span", {
      className: "team-name"
    }, currentMatch.rival_name), m("span", {
      className: "team-tag"
    }, "Local")), m("div", {
      className: "matchup-vs"
    }, "VS"), m("div", {
      className: "team-box away-team"
    }, m("img", {
      src: athleticEscudo,
      alt: "Athletic Club",
      className: "team-crest",
      style: {
        width: '58px',
        height: '58px',
        maxWidth: '58px',
        maxHeight: '58px',
        objectFit: 'contain'
      }
    }), m("span", {
      className: "team-name"
    }, "Athletic Club"), m("span", {
      className: "team-tag"
    }, "Visitante")))), m("div", {
      className: "question-prompt"
    }, "\xBFCu\xE1l fue el resultado oficial de este encuentro?"), m("div", {
      className: "score-options-grid"
    }, currentMatch.options.map(opt => {
      const isPicked = selectedAnswer === opt.key;
      const isSuspended = opt.key === 'SUSPENDED';
      let feedbackClass = '';
      if (this.isSurvival && this.survivalFeedback) {
        if (opt.key === currentMatch.correct_key) {
          feedbackClass = 'is-correct-pick';
        } else if (isPicked && !this.survivalFeedback.isCorrect) {
          feedbackClass = 'is-wrong-pick';
        }
      }
      return m("button", {
        type: "button",
        className: "score-option-btn ".concat(isPicked ? 'is-selected' : '', " ").concat(isSuspended ? 'is-suspended' : '', " ").concat(feedbackClass),
        onclick: () => this.selectOption(currentMatch.id, opt.key)
      }, m("div", {
        className: "opt-indicator"
      }, m("i", {
        className: isPicked ? 'fas fa-check-circle' : 'far fa-circle'
      })), m("span", {
        className: "opt-label"
      }, opt.label));
    }))), m("div", {
      className: "game-footer-bar"
    }, this.isSurvival ? m("div", {
      style: {
        color: '#64748b',
        fontSize: '13px',
        fontWeight: 600
      }
    }, m("i", {
      className: "fas fa-heartbeat",
      style: {
        color: '#ef4444',
        marginRight: '6px'
      }
    }), "Modo Muerte S\xFAbita \xB7 Cada respuesta err\xF3nea cuesta 1 vida de Le\xF3n") : m(Button, {
      className: "Button Button--link btn-skip-match",
      icon: "fas fa-forward",
      onclick: () => this.skipCurrentMatch()
    }, "Pasar partido (responder luego)"), m("div", {
      className: "footer-right-actions"
    }, !this.isSurvival && m("span", {
      className: "answered-counter"
    }, answeredCount, " de ", this.matches.length, " respondidos"), !this.isSurvival && allDone && m(Button, {
      className: "Button Button--primary btn-finish-round",
      icon: "fas fa-flag-checkered",
      loading: this.submitting,
      onclick: () => this.submitClassicRound()
    }, "Finalizar Tanda"), !this.isSurvival && !allDone && m(Button, {
      className: "Button Button--secondary",
      icon: "fas fa-arrow-right",
      onclick: () => {
        const nextIdx = this.findNextUnansweredIndex(this.currentIndex);
        if (nextIdx !== -1) {
          this.currentIndex = nextIdx;
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.matches.length;
        }
        m.redraw();
      }
    }, "Siguiente"))));
  }
  renderResults() {
    const r = this.results || {};
    const isLoggedIn = Boolean(app.session.user);
    const baseUrl = (app.forum.attribute('baseUrl') || '').replace(/\/$/, '');

    // --- RESULTADOS MODO MUERTE SÚBITA ---
    if (this.isSurvival) {
      const streak = r.rounds_survived || this.survivalStreak;
      const durationSec = r.duration_seconds || this.timerSeconds;
      const recordUpdated = Boolean(r.is_new_record);
      const items = r.results || [];
      const expelledLionUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-expulsado");
      return m("div", {
        className: "bolilla-retro-game results-screen"
      }, m("div", {
        className: "results-summary-card"
      }, m("div", {
        className: "survival-gameover-banner"
      }, m("img", {
        src: expelledLionUrl,
        className: "gameover-lion-img",
        alt: "Le\xF3n Expulsado"
      }), m("h3", null, "\xA1EXPULSADO POR TRIPLE FALLO!"), m("p", null, "El colegiado te muestra la tarjeta roja tras agotar tus 3 vidas de le\xF3n. Has sobrevivido hasta la ", m("strong", null, "Ronda ", streak), ".")), m("div", {
        className: "score-hero"
      }, m("div", {
        className: "score-circle"
      }, m("span", {
        className: "score-val"
      }, streak), m("span", {
        className: "score-lbl"
      }, "Rondas Superadas"))), m("div", {
        className: "stats-row"
      }, m("div", {
        className: "stat-box"
      }, m("span", {
        className: "stat-num"
      }, streak), m("span", {
        className: "stat-label"
      }, "Ronda M\xE1x")), m("div", {
        className: "stat-box"
      }, m("span", {
        className: "stat-num"
      }, this.formatTimer(durationSec)), m("span", {
        className: "stat-label"
      }, "Tiempo")), m("div", {
        className: "stat-box"
      }, m("span", {
        className: "stat-num"
      }, r.high_score || streak), m("span", {
        className: "stat-label"
      }, "Tu R\xE9cord"))), recordUpdated && m("div", {
        className: "record-badge"
      }, m("i", {
        className: "fas fa-trophy"
      }), " \xA1Nuevo r\xE9cord personal en Muerte S\xFAbita!"), !isLoggedIn && m("div", {
        className: "guest-warning"
      }, m("p", null, "Inicia sesi\xF3n o reg\xEDstrate para que tu r\xE9cord de Muerte S\xFAbita figure en el Sal\xF3n de la Fama."), m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-sign-in-alt",
        onclick: () => app.modal.show(LogInModal)
      }, "Iniciar Sesi\xF3n")), m("div", {
        className: "results-actions"
      }, m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-redo",
        onclick: () => this.fetchNewRound()
      }, "Jugar Otra Muerte S\xFAbita"))), items.length > 0 && m("div", {
        className: "results-matches-list"
      }, m("h4", null, "Desglose de Partidos de la Partida"), m("div", {
        className: "review-cards-grid"
      }, items.map((item, i) => {
        const isOk = Boolean(item.is_correct);
        return m("div", {
          key: item.id || i,
          className: "review-card ".concat(isOk ? 'is-correct' : 'is-wrong')
        }, m("div", {
          className: "review-status-badge"
        }, isOk ? m("span", null, m("i", {
          className: "fas fa-check-circle"
        }), " Acierto (Ronda superada)") : m("span", null, m("i", {
          className: "fas fa-heart-broken"
        }), " Fallo (-1 vida de Le\xF3n)")), m("div", {
          className: "review-card-body"
        }, m("div", {
          className: "review-rival"
        }, m("strong", null, "Ronda ", i + 1, ":"), " vs ", item.rival_name), m("div", {
          className: "review-user-pick"
        }, m("span", {
          className: "pick-label"
        }, "Tu pron\xF3stico:"), m("span", {
          className: "pick-val ".concat(isOk ? 'correct' : 'wrong')
        }, item.user_answer)), m("div", {
          className: "review-actual-result"
        }, m("span", {
          className: "pick-label"
        }, "Resultado real:"), m("span", {
          className: "pick-val actual"
        }, item.actual_label))));
      }))), m("div", {
        className: "results-leaderboard-section"
      }, m("h4", null, "\uD83E\uDD81 Sal\xF3n de la Fama: Muerte S\xFAbita"), m(PasatiemposLeaderboard, {
        initialFilter: "bolilla_retro_survival",
        hideFilters: true,
        compact: true,
        maxItems: 10
      })));
    }

    // --- RESULTADOS MODO CLÁSICO ---
    const score = r.score || 0;
    const correctCount = r.correct_count || 0;
    const totalMatches = r.total_matches || 5;
    const durationSec = r.duration_seconds || this.timerSeconds;
    const isPerfect = Boolean(r.is_perfect);
    const recordUpdated = Boolean(r.is_new_record);
    const items = r.results || [];
    return m("div", {
      className: "bolilla-retro-game results-screen"
    }, m("div", {
      className: "results-summary-card"
    }, isPerfect && m("div", {
      className: "perfect-banner"
    }, m("span", {
      className: "celebration-emoji"
    }, "\uD83E\uDD81\uD83C\uDF89"), m("h3", null, "\xA1PLENO ZURIGORRI!"), m("p", null, "\xA15 de 5 aciertos con memoria de aut\xE9ntico le\xF3n en el Nivel ", this.selectedLevel, "!")), m("div", {
      className: "score-hero"
    }, m("div", {
      className: "score-circle"
    }, m("span", {
      className: "score-val"
    }, score), m("span", {
      className: "score-lbl"
    }, "Puntos"))), m("div", {
      className: "stats-row"
    }, m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, correctCount, " / ", totalMatches), m("span", {
      className: "stat-label"
    }, "Aciertos")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, this.formatTimer(durationSec)), m("span", {
      className: "stat-label"
    }, "Tiempo")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, r.high_score || score), m("span", {
      className: "stat-label"
    }, "Tu R\xE9cord"))), recordUpdated && m("div", {
      className: "record-badge"
    }, m("i", {
      className: "fas fa-trophy"
    }), " \xA1Nuevo r\xE9cord personal en Bolilla Retro Nivel ", this.selectedLevel, "!"), !isLoggedIn && m("div", {
      className: "guest-warning"
    }, m("p", null, "Inicia sesi\xF3n o reg\xEDstrate para que tu puntuaci\xF3n compute en la clasificaci\xF3n general de Pasatiempos."), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-sign-in-alt",
      onclick: () => app.modal.show(LogInModal)
    }, "Iniciar Sesi\xF3n")), m("div", {
      className: "results-actions",
      style: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center'
      }
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-redo",
      onclick: () => this.fetchNewRound()
    }, "Jugar Otra Tanda"), m(Button, {
      className: "Button Button--secondary",
      icon: "fas fa-arrow-right",
      onclick: () => this.selectLevel(this.selectedLevel < 3 ? this.selectedLevel + 1 : 1, false)
    }, this.selectedLevel < 3 ? "Probar Nivel ".concat(this.selectedLevel + 1) : 'Volver a Nivel 1'))), m("div", {
      className: "results-matches-list"
    }, m("h4", null, "Desglose de Partidos de la Tanda"), m("div", {
      className: "review-cards-grid"
    }, items.map((item, i) => {
      const isOk = Boolean(item.is_correct);
      return m("div", {
        key: item.id || i,
        className: "review-card ".concat(isOk ? 'is-correct' : 'is-wrong')
      }, m("div", {
        className: "review-status-badge"
      }, isOk ? m("span", null, m("i", {
        className: "fas fa-check-circle"
      }), " Acierto (+200 pts base)") : m("span", null, m("i", {
        className: "fas fa-times-circle"
      }), " Fallo (0 pts)")), m("div", {
        className: "review-card-body"
      }, m("div", {
        className: "review-rival"
      }, m("strong", null, "Partido ", i + 1, ":"), " vs ", item.rival_name), m("div", {
        className: "review-user-pick"
      }, m("span", {
        className: "pick-label"
      }, "Tu pron\xF3stico:"), m("span", {
        className: "pick-val ".concat(isOk ? 'correct' : 'wrong')
      }, item.user_answer)), m("div", {
        className: "review-actual-result"
      }, m("span", {
        className: "pick-label"
      }, "Resultado real:"), m("span", {
        className: "pick-val actual"
      }, item.actual_label))));
    }))), m("div", {
      className: "results-leaderboard-section"
    }, m("h4", null, "\uD83C\uDFC6 Top Foreros en Bolilla Retro"), m(PasatiemposLeaderboard, {
      initialFilter: "bolilla_retro",
      hideFilters: true,
      compact: true,
      maxItems: 10
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/BolillaRetroGame', BolillaRetroGame);